/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_ProcessingInputs */

const en_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing...`)
};

const fr_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement...`)
};

const de_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung...`)
};

const it_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione in corso...`)
};

const ru_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка...`)
};

const es_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tratamiento...`)
};

const zh_cn2_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加工...`)
};

const ja_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理...`)
};

const hi_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रक्रिया जारी है...`)
};

const pt_pt2_team_manager_processing = /** @type {(inputs: Team_Manager_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processamento...`)
};

/**
* | output |
* | --- |
* | "Processing..." |
*
* @param {Team_Manager_ProcessingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_processing = /** @type {((inputs?: Team_Manager_ProcessingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_ProcessingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_processing(inputs)
	if (locale === "de") return de_team_manager_processing(inputs)
	if (locale === "it") return it_team_manager_processing(inputs)
	if (locale === "ru") return ru_team_manager_processing(inputs)
	if (locale === "es") return es_team_manager_processing(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_processing(inputs)
	if (locale === "ja") return ja_team_manager_processing(inputs)
	if (locale === "hi") return hi_team_manager_processing(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_processing(inputs)
	return en_team_manager_processing(inputs)
});